import { Component, OnInit, Input, Output, EventEmitter, Renderer2 } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { OrderService } from 'src/app/services/order.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-address-validation',
  templateUrl: './address-validation.component.html',
  styleUrls: ['./address-validation.component.scss']
})
export class AddressValidationComponent implements OnInit {

  showLoadingButton = false;
  radioBtnFormGroup: FormGroup;
  currentCheckedValue = null;
  showBypassWarning = false;

  constructor(
    private formBuilder: FormBuilder,
    private orderService: OrderService,
    private translateService: TranslateService,
    private ren: Renderer2
  ) { }

  @Input()
  modalDialogHeaderContent;

  @Input()
  modalInputAddressData;

  @Input()
  modalStandardizedAddressData;

  @Input()
  modalDialogBodyContent = 'bodyContent';

  @Input()
  modalDialogType = 'BLOCK_TOAST';

  @Input()
  modalButtonVal = this.translateService.instant('COMMON.CommonAddressvalidButton_Usethisaddress', {Default: 'Use This Address'});
 
  @Input()
  addressAsEntered;

  @Input()
  validationErrorMessage: string;

  @Output() cancelModalDialogEvent = new EventEmitter<boolean>();

  @Output() submitModalDialogEvent = new EventEmitter<string>();

  @Output() selectionEvent = new EventEmitter<number>();

  ngOnInit(): void {

    this.radioBtnFormGroup = this.formBuilder.group({
      radioSelection: ['', Validators.required]
    });

    this.modalDialogHeaderContent = this.modalDialogHeaderContent ? this.modalDialogHeaderContent : this.translateService.instant('COMMON.CommonAddressvalidTitle_Addressvalidation', {Default: 'Address Validation'});
    this.modalInputAddressData = this.modalInputAddressData ? this.modalInputAddressData : [];
    this.modalStandardizedAddressData = this.modalStandardizedAddressData ? this.modalStandardizedAddressData : [];
  }

  raiseModalEvent(eventAction) {
    if (eventAction === 'cancel') {
      this.cancelModalDialogEvent.emit(true);
    } else if (eventAction === 'submit') {
      this.showLoadingButton = true;
      this.submitModalDialogEvent.emit(this.modalButtonVal);
      this.selectionEvent.emit(this.radioBtnFormGroup.value);
    }
  }

  get radioSelection() {
    return this.radioBtnFormGroup.get('radioSelection') as FormControl;
  }
  checkState(el) {
    setTimeout(() => {
      if (this.currentCheckedValue && this.currentCheckedValue === el.value) {
        el.checked = false;
        this.ren.removeClass(el['_elementRef'].nativeElement, 'cdk-focused');
        this.ren.removeClass(el['_elementRef'].nativeElement, 'cdk-program-focused');
        this.currentCheckedValue = null;
        this.showBypassWarning = false;
      } else {
        this.currentCheckedValue = el.value;
        this.showBypassWarning = (el.value === 0);
      }
    })
  }
}
